
import {
  useQuery,
} from 'react-query';

import { useMiddleman } from '@hubins/middleman';
import { tradeOrdersHandler } from './responseFormatter';

export const useTradeOrders = (portfolioUuid: string) => {
  const middleman = useMiddleman();
  return useQuery(['tradeOrders', portfolioUuid], () => {
    return middleman.get(
      `/v1/fa/tradeorder/index/${portfolioUuid}`
    ).then((response) => {
      return tradeOrdersHandler(response);
    });
  }, { enabled: !!portfolioUuid, refetchOnWindowFocus: false});
};